import productService from '../api';
import {
  SET_PRODUCT,
  SET_PLUGIN_INFO,
  SET_BRIEFS,
  SET_BRIEFS_LOADING,
  SET_ADOBE_RATING,
  SET_RATING_LOADING,
  SET_RATING_PAGINATION,
  SET_RATING_PREVIEW,
  SET_RATING_HISTORY,
  SET_RATING_LIKE,
} from './product.constants';

export const getPluginTC = (type) => {
  return async (dispatch) => {
    try {
      const data = await productService.getPlugin(type);

      if(data?.status === 200) {
        const blob = new Blob([data.data], {
          type: 'application/zip',
        });

        return blob;
      }

      throw new Error("The server did not return a result");
    } catch (error) {
      console.log(error);
      alert('Error download file.', error)
    }
  }
}

export const getPluginInfoTC = () => {
  return async (dispatch) => {
    try {
      const resp = await productService.getPluginInfo();
      
      dispatch(setPluginInfoAC(resp?.data));
    } catch (error) {
      console.log(error);
    }
  }
}

export const getBriefsTC = () => {
  return async (dispatch) => {
    try {
      const resp = await productService.getBriefs();

      dispatch(setBriefsAC(resp?.data));
    } catch (error) {
      console.log(error);
    }
  }
}

// isFull — запрашивать полную выдачу (эндпоинт за авторизацией) вместо публичной витрины.
// Возвращает статус, чтобы страница могла увести пользователя обратно на публичный роут,
// если доступ не дали (401 — сессия протухла, 403 — нет adobe или мало отпарсенных ниш).
export const getAdobeRatingTC = (params, isFull = false) => {
  return async (dispatch) => {
    try {
      const data = isFull
        ? await productService.getAdobeRatingFull(params)
        : await productService.getAdobeRating(params);

      if (!data) {
        return { ok: false };
      }

      let { rows, count } = data.data;

      if (!count) {
        count = 1;
      }

      dispatch(setAdobeRatingAC(rows));
      dispatch(setRatingPaginationAC(count))
      // Признак урезанной выдачи решает бэкенд — клиент не дублирует проверку доступа adobe.
      dispatch(setRatingPreviewAC(data.data?.isPreview))

      return { ok: true };
    } catch (error) {
      const status = error?.response?.status;

      // 403 — штатный отказ гейта (нет доступа adobe либо мало отпарсенных ниш). Страница его
      // ловит и показывает плашкой с облаком ниш, то есть это ожидаемая ветка, а не сбой —
      // в консоль не пишем, иначе нормальная работа выглядит как поток ошибок.
      if (status !== 403) console.log(error);

      // Отдаём и статус, и тело: у 403 «мало ниш» внутри лежат parsedNiches/requiredNiches,
      // из них страница строит подсказку, сколько ещё осталось отпарсить.
      return {
        ok: false,
        status,
        data: error?.response?.data,
      };
    }
  }
}

// Данные держит сам виджет, а не стор: подсказка показывается в одном месте и живёт ровно
// столько, сколько видна плашка отказа — заводить ради неё срез состояния незачем.
export const getParseSuggestionsTC = () => {
  return async () => {
    try {
      const data = await productService.getParseSuggestions();

      return data?.data?.suggestions || [];
    } catch (error) {
      console.log(error);
      return [];
    }
  }
}

// Ставит/снимает лайк ниши и патчит именно эту строку в сторе — перезапрашивать всю страницу
// таблицы ради одного счётчика незачем, а положение строки при сортировке/фильтре по лайкам
// нарочно не трогаем: у "только избранное" строка не должна пропадать из-под курсора сразу же
// после снятия лайка тем же кликом.
export const toggleAdobeRatingLikeTC = (id) => {
  return async (dispatch) => {
    try {
      const { data } = await productService.toggleAdobeRatingLike(id);

      dispatch(setRatingLikeAC({ id, isLiked: data?.liked, likesCount: data?.likesCount }));

      return data;
    } catch (error) {
      console.log(error);
    }
  }
}

export const getAdobeRatingHistoryTC = (id) => {
  return async (dispatch) => {
    try {
      const data = await productService.getAdobeRatingHistory(id);
      // Бэкенд отдаёт от новых к старым, графику нужен обратный порядок.
      const history = data?.data?.history || [];

      dispatch(setRatingHistoryAC([...history].reverse()));
    } catch (error) {
      // 403 — нет доступа adobe, это штатный ответ для витрины, а не сбой: молчим, как и в
      // getAdobeRatingTC. Витрина открыта всем, и без этого консоль засорялась бы на каждой
      // смене выбранной строки.
      if (error?.response?.status !== 403) console.log(error);

      dispatch(setRatingHistoryAC([]));
    }
  }
}

//ACTIONS
export const setProductAC = (payload) => {
  return {
    type: SET_PRODUCT,
    payload,
  };
};

export const setPluginInfoAC = (payload) => {
  return {
    type: SET_PLUGIN_INFO,
    payload,
  };
};

export const setBriefsAC = (payload) => {
  return {
    type: SET_BRIEFS,
    payload,
  };
};

export const setBriefsLoadingAC = (payload) => {
  return {
    type: SET_BRIEFS_LOADING,
    payload,
  };
}

export const setAdobeRatingAC = (payload) => {
  return {
    type: SET_ADOBE_RATING,
    payload,
  }
}

export const setRatingLoadingAC = (payload) => {
  return {
    type: SET_RATING_LOADING,
    payload,
  };
}

export const setRatingPaginationAC = (payload) => {
  return {
    type: SET_RATING_PAGINATION,
    payload,
  }
}

export const setRatingPreviewAC = (payload) => {
  return {
    type: SET_RATING_PREVIEW,
    payload,
  }
}

export const setRatingHistoryAC = (payload) => {
  return {
    type: SET_RATING_HISTORY,
    payload,
  }
}

export const setRatingLikeAC = (payload) => {
  return {
    type: SET_RATING_LIKE,
    payload,
  }
}
